"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputHtml = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const tinymce_react_1 = require("@tinymce/tinymce-react");
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const api_1 = __importDefault(require("../../lib/api"));
const AppSnackbar_1 = __importDefault(require("../../snackbar/AppSnackbar"));
const InputHtml_hooks_1 = require("./InputHtml.hooks");
const InputHtmlImageDialog_1 = __importDefault(require("./InputHtmlImageDialog"));
const useAttachNewImages_1 = require("./useAttachNewImages");
const useImageReloader_1 = require("./useImageReloader");
const StyledButtonGroup = (0, styled_components_1.default)(core_1.ButtonGroup) `
  border: 1px solid #ccc;
  border-top: 0;
  border-radius: 0;
`;
const InputHtml = props => {
    const { value, disabled, label, height, helperText, uploader, enableMedia = false, hideConfirm = false, grid = { xs: 12 }, attachments = [], proxyOptions: proxyOptionsProp, onChange, onChangeAttachments, onCompleteUpload } = props;
    const noAutoResize = !!height;
    const currValueRef = (0, react_1.useRef)(value);
    currValueRef.current = value;
    const previousValueRef = (0, react_1.useRef)(value);
    // eslint-disable-next-line @typescript-eslint/ban-types
    const setImageCallbackRef = (0, react_1.useRef)();
    const [focus, setFocus] = (0, react_1.useState)(false);
    const [buttonFocus, setButtonFocus] = (0, react_1.useState)(false);
    const [didInit, setDidInit] = (0, react_1.useState)(false);
    const [isDialogOpen, setIsDialogOpen] = (0, react_1.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    // default to forms/file
    const proxyOptions = (0, react_1.useMemo)(() => {
        return {
            key: (proxyOptionsProp === null || proxyOptionsProp === void 0 ? void 0 : proxyOptionsProp.key) || 'key',
            path: (proxyOptionsProp === null || proxyOptionsProp === void 0 ? void 0 : proxyOptionsProp.path) || 'forms/file'
        };
    }, [proxyOptionsProp === null || proxyOptionsProp === void 0 ? void 0 : proxyOptionsProp.key, proxyOptionsProp === null || proxyOptionsProp === void 0 ? void 0 : proxyOptionsProp.path]);
    const { error, reloadFailedImages } = (0, useImageReloader_1.useImageReloader)();
    const { inspectAndUpload } = (0, useAttachNewImages_1.useAttachNewImages)({
        uploader,
        attachments,
        proxyOptions,
        onCompleteUpload,
        onChangeAttachments
    });
    const toolbar = (0, react_1.useMemo)(() => {
        const str = [
            'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify',
            `image ${enableMedia ? 'media' : ''}`,
            'link bullist numlist outdent indent | removeformat | help | code'
        ];
        return str.join(' | ');
    }, [enableMedia]);
    const setValue = (value) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    const handleSubmit = () => {
        setFocus(false);
    };
    const handleCancel = () => {
        setValue(previousValueRef.current);
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    const filePickerCallback = (setImageCallback) => {
        setImageCallbackRef.current = setImageCallback;
        setIsDialogOpen(true);
    };
    (0, react_1.useEffect)(() => {
        error && setErrorMessage(error);
    }, [error]);
    return (react_1.default.createElement(core_1.Grid, Object.assign({ item: true }, grid),
        label && (react_1.default.createElement(core_1.Typography, { variant: 'h5', gutterBottom: true }, label)),
        !didInit && (react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary', style: { marginTop: 10 } }, "Loading editor...")),
        react_1.default.createElement(tinymce_react_1.Editor, { apiKey: api_1.default.environment.tinyApiKey, key: `${disabled}-${noAutoResize}-${enableMedia}`, value: value, init: {
                height,
                menubar: false,
                paste_data_images: true,
                relative_urls: false,
                remove_script_host: false,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste help wordcount',
                    noAutoResize ? '' : 'autoresize',
                    enableMedia ? 'media' : ''
                ],
                toolbar,
                file_picker_callback: filePickerCallback
            }, disabled: disabled, onFocus: () => setFocus(true), onInit: (event) => {
                var _a;
                const iframe = (_a = event.target) === null || _a === void 0 ? void 0 : _a.iframeElement;
                (0, InputHtml_hooks_1.applyImageStyling)(iframe);
                reloadFailedImages(iframe);
                setDidInit(true);
            }, onBlur: () => setValue(value), onEditorChange: (content, editor) => __awaiter(void 0, void 0, void 0, function* () {
                reloadFailedImages(editor.iframeElement);
                // remove `data-mce-id="__mcenew" ` to fix infinite re-render
                content = (content === null || content === void 0 ? void 0 : content.replace(/data-mce-id="__mcenew" /g, '')) || '';
                try {
                    const replacedValue = yield inspectAndUpload(content);
                    const newValue = typeof replacedValue === 'string' ? replacedValue : content;
                    // avoid infinite re-render
                    if (newValue !== currValueRef.current) {
                        setValue(newValue);
                    }
                }
                catch (error) {
                    console.error('InputHtml error:', error);
                    if (error) {
                        setErrorMessage(error instanceof Error ? error.message : `${error}`);
                        setValue(content);
                    }
                }
            }), onKeyDown: event => {
                // resetSessionTime();
                switch (event.key) {
                    case 'Escape':
                        return handleCancel();
                }
            } }),
        react_1.default.createElement(core_1.Collapse, { in: !hideConfirm && didInit && (focus || buttonFocus) },
            react_1.default.createElement(StyledButtonGroup, { fullWidth: true, color: 'primary', variant: 'text' },
                react_1.default.createElement(core_1.Button, { fullWidth: true, onFocus: () => setButtonFocus(true), onBlur: () => setButtonFocus(false), onClick: event => {
                        event.stopPropagation();
                        setButtonFocus(false);
                        handleSubmit();
                    } },
                    react_1.default.createElement(icons_1.Done, null)),
                react_1.default.createElement(core_1.Button, { fullWidth: true, onFocus: () => setButtonFocus(true), onBlur: () => setButtonFocus(false), onClick: event => {
                        event.stopPropagation();
                        setFocus(false);
                        setButtonFocus(false);
                        handleCancel();
                    } },
                    react_1.default.createElement(icons_1.Clear, null)))),
        didInit && helperText && react_1.default.createElement(core_1.FormHelperText, null, helperText),
        react_1.default.createElement(InputHtmlImageDialog_1.default, { open: isDialogOpen, attachments: attachments, proxyOptions: proxyOptions, onCompleteUpload: onCompleteUpload, onChangeAttachments: onChangeAttachments, onCancel: () => setIsDialogOpen(false), onSelect: storageKey => {
                var _a;
                // TODO: convert to url
                setIsDialogOpen(false);
                (_a = setImageCallbackRef.current) === null || _a === void 0 ? void 0 : _a.call(setImageCallbackRef, storageKey);
            } }),
        react_1.default.createElement(AppSnackbar_1.default, { severity: 'error', open: !!errorMessage, onClose: () => setErrorMessage('') }, errorMessage)));
};
exports.InputHtml = InputHtml;
exports.default = exports.InputHtml;
//# sourceMappingURL=InputHtml.js.map